import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, ElementRef,
  HostBinding, Inject, Input, OnDestroy, PLATFORM_ID, Renderer2, ViewChild,
} from '@angular/core';
import { TableIdentityColComponent } from './table-identity-col.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'mtg-table',
  templateUrl: './table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class.statistic-table')
  defaultClass = true;
  @HostBinding('class.with-groups')
  withGroups: boolean;
  @Input()
  small = false;
  @Input()
  bordered = true;
  @Input()
  withScroll = true;
  @Input()
  stickyTop = 0;
  @Input()
  showScrollArrows: boolean;

  @ViewChild('scroll', {read: ElementRef})
  scroll: ElementRef;
  hasIdentityCol: boolean;

  canScrollRight: boolean;
  canScrollLeft: boolean;

  private subscriptions: (() => void)[] = [];

  @HostBinding('class.statistic-table--small')
  get smallClass(): boolean {
    return this.small;
  }
  @HostBinding('class.statistic-table--bordered')
  get borderedClass(): boolean {
    return this.bordered;
  }
  @HostBinding('class.with-scroll')
  get withScrollClass(): boolean {
    return this.withScroll;
  }
  @HostBinding('class.has-identity-col')
  get hasIdentityColClass(): boolean {
    return Boolean(this.hasIdentityCol);
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private renderer2: Renderer2,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.subscriptions.push(
      this.renderer2.listen(this.scroll.nativeElement, 'scroll', () => this.checkScroll())
    );
    this.subscriptions.push(
      this.renderer2.listen('window', 'resize', () => this.checkScroll())
    );
    setTimeout(() => {
      this.checkScroll();
    }, 100);
  }

  ngOnDestroy(): void {
    for (const unsubscribe of this.subscriptions) {
      unsubscribe();
    }
  }

  scrollLeft() {
    if (!this.canScrollLeft) {
      return;
    }
    let scrollWidth = this.scroll.nativeElement.scrollLeft - this.scroll.nativeElement.clientWidth / 2;
    if (scrollWidth < 10) {
      scrollWidth = 0;
    }
    this.scroll.nativeElement.scroll({left: scrollWidth, top: 0, behavior: 'smooth'});
  }

  scrollRight() {
    if (!this.canScrollRight) {
      return;
    }
    let scrollWidth = this.scroll.nativeElement.scrollLeft + this.scroll.nativeElement.clientWidth / 2;
    if (scrollWidth > this.scroll.nativeElement.scrollWidth) {
      scrollWidth = this.scroll.nativeElement.scrollWidth;
    }
    this.scroll.nativeElement.scroll({left: scrollWidth, top: 0, behavior: 'smooth'});
  }

  private checkScroll() {
    const scrollWidth = this.scroll.nativeElement.scrollWidth - this.scroll.nativeElement.scrollLeft;
    this.canScrollRight = scrollWidth > this.scroll.nativeElement.clientWidth;
    this.canScrollLeft = this.scroll.nativeElement.scrollLeft > 0;
    this.cdr.markForCheck();
  }
}
